import { listResource } from './listResource';

export async function listUserActivities(options = {}) {
  return listResource('/user-activity', options);
}
